import styled from '@emotion/styled';

import { MultilineInput } from 'components/inputs/input/multilineInput';
import LoadingIndicator from 'components/loadingIndicator/loadingIndicator';

export const PaymentRailOptionsContainer = styled.div(() => ({
  display: 'grid',
  gridTemplateColumns: 'auto auto',
  gap: 16,
  width: '100%',
  maxWidth: 290,
}));

export const SecondaryText = styled.span(({ theme }) => ({
  fontSize: 13,
  fontWeight: 400,
  fontFamily: theme.fonts.primary,
  color: theme.colors.inactive,
}));

export const GridLightText = styled(SecondaryText)(() => ({
  textAlign: 'right',
}));

export const RadioLabel = styled.div(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

export const ExtraPadding = styled.div(() => ({
  padding: 82,
}));

export const StyledLoadingIndicator = styled(LoadingIndicator)(({ theme }) => ({
  '& path': {
    fill: theme.colors.accent,
  },
}));

export const ModalWithImageContent = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: 16,
  '& h1': {
    fontSize: 16,
    fontWeight: 600,
    margin: 0,
  },
  '& p': {
    padding: '0 35px',
    fontSize: 13,
    fontWeight: 400,
    margin: 0,
  },
}));

export const StyledMultilineInput = styled(MultilineInput)<{ error?: boolean }>(({ theme, error }) => ({
  maxWidth: 290,
  border: `1px solid ${error ? theme.colors.error.main : 'unset'} !important`,
}));

export const ErrorText = styled.span(({ theme }) => ({
  color: theme.colors.error.main,
  fontSize: 12,
  fontWeight: 500,
  maxWidth: 290,
}));

export const AddNewItemSelectItem = styled.div(({ theme }) => ({
  gap: 6,
  display: 'flex',
  alignItems: 'center',
  path: {
    fill: theme.colors.inactive,
  },
}));

export const Notice = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  fontSize: 12,
  fontWeight: 400,
  color: theme.colors.inactive,
  path: {
    fill: theme.colors.inactive,
  },
}));
